import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { AcoService } from '../../api/aco.service';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-task-filters',
  templateUrl: './task-filters.page.html',
  styleUrls: ['./task-filters.page.scss'],
})
export class TaskFiltersPage implements OnInit {

  public order_by = null;
  public task_status_id = null;
  public date_from = null;
  public date_to = null;
  public employee_id = null;
  public title = null;
  public code = null;
  public search_by_text = null;
  public archived = false;
  is_supervisor = false;
  public task_status = [];
  public employees = [];
  private filters = [];

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    public aco: AcoService,
    public ionLoader: LoaderService,
  ) {
    console.log("taskfilter");
    this.filters = navParams.get('filters');
  }

  ngOnInit() {
    this.ionLoader.showLoader();
    this.aco.getToken().then((a) => {
      this.aco.loadFiltersTask()
      .subscribe(
        (response) => {
          this.task_status = response['data']['task_status'];
          this.employees = response['data']['employees'];
          this.is_supervisor = response['data']['is_supervisor'];
          this.ionLoader.hideLoader();
          this.filtros_formulario(this.filters);
        },
        (error) => {
          console.log('bad');
          this.ionLoader.hideLoader();
        }
      );
    });
  }

  // Poner el valor de cada campo en el formulario
  filtros_formulario(filters){
    if(filters['task_status_id'] != undefined){
      this.task_status_id = filters['task_status_id'];
    }
    if(filters['date_from'] != undefined){
      this.date_from = filters['date_from'];
    }
    if(filters['date_to'] != undefined){
      this.date_to = filters['date_to'];
    }
    if(filters['employee_id'] != undefined){
      this.employee_id = filters['employee_id'];
    }
    if(filters['title'] != undefined){
      this.title = filters['title'];
    }
    if(filters['code'] != undefined){
      this.code = filters['code'];
    }
    if(filters['archived'] != undefined){
      this.archived = filters['archived'];
    }
    if(filters['search_by_text'] != undefined){
      this.search_by_text = filters['search_by_text'];
    }

    // ordenación
    if(filters['order_by'] != undefined){
      this.order_by = filters['order_by'];
    }
  }

  guardar(formulario:NgForm){
    console.log(formulario.value);
    this.modalController.dismiss({
      'dismissed': true,
      'with_filters': true,
      'filters': formulario.value
    });
  }

  reset(formulario:NgForm){
    formulario.reset();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true,
      'with_filters': false,
    });
  }

}
